import { Observable, of } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { ContentGenerator } from './content-generator';
import { Address, MarketingOrder, OutputMimeType, ProductInstance } from '../models';
import { MarketingOrderService } from './marketing-order.service';

@Injectable()
export class WebsiteGenerationService implements ContentGenerator {
  private marketingOrderService = inject(MarketingOrderService);

  mimeType = OutputMimeType.html;
  downloadable = false;

  generate(order: MarketingOrder, product: ProductInstance, otherData?: { consent?: boolean }): Observable<any> {
    const hasConsent = otherData && otherData.consent === true;
    return this.marketingOrderService.publishWebsite(order._id, hasConsent);
  }

  unpublish(order: MarketingOrder): Observable<any> {
    return this.marketingOrderService.unPublishWebsite(order._id);
  }

  download(order: MarketingOrder, product: ProductInstance, imageResolution?: string, isDownload?: boolean): Observable<any> {
    return of(null);
  }

  downloadById(marketingOrderId: string, address: Address, product: ProductInstance | { title: string, code: string }): void {}
}
